import {Button, Stack, Typography, useTheme} from "@mui/joy";
import React from "react";
import {CircleAlert} from "lucide-react";
import {useTranslation} from "react-i18next";

type LoadingErrorProps = {
    label?: string
    onRetry?: () => void,
    action?: "submit" | "load",
    abstractText?: string
}

const LoadingError = ({onRetry, action = "load", label, abstractText = ""}: LoadingErrorProps) => {
    const theme = useTheme()
    const {t} = useTranslation()

    // Takes the place of the content that failed, centred in that space rather than tucked under the header.
    return <Stack flex={1} minHeight={{xs: "40dvh", md: "50dvh"}} alignItems={"center"} justifyContent={"center"}
                  gap={2} paddingY={3} paddingX={2} width={"100%"} boxSizing={"border-box"}>
        <CircleAlert style={{color: theme.palette.danger['500'], fontSize: 72}}/>
        <Typography level={"body-lg"} textAlign={"center"} maxWidth={"28rem"}>
            {abstractText || t(action === "submit" ? "submitErrorMessage" : "loadingErrorMessage", {label})}
        </Typography>
        <Button onClick={onRetry} variant={"outlined"} size={"lg"} color={"danger"} sx={{width: "10rem"}}>
            {t("retryActionLabel")}
        </Button>
    </Stack>
}

export default LoadingError
